import { render, staticRenderFns } from "./overPrices.vue?vue&type=template&id=41417893"
import script from "./overPrices.vue?vue&type=script&lang=js"
export * from "./overPrices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports